import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  loanAmount?: number;
  pmiPercentage?: number;
}

export const calculatePmi = (
  form: FormInstance,
  loanIndex: string | number,
  {
    loanAmount,
    pmiPercentage
  }: FieldValues = {}
): number => {
  const loanAmountValue =
    loanAmount ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmount', 'value'])) || 0);

  const pmiPercentageValue =
    pmiPercentage ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'pmiPercentage'])) || 0);


  return parseFloat(formatAmount(((loanAmountValue * (pmiPercentageValue / 100)) / 12)))
}

